<template>
  <v-btn icon small v-if="false">
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "VisibilidadeDeColunas.vue"
}
</script>

<style scoped>

</style>
